import { render, staticRenderFns } from "./RoomCloseInventory.vue?vue&type=template&id=547ebd58&"
import script from "./RoomCloseInventory.vue?vue&type=script&lang=js&"
export * from "./RoomCloseInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports